import {VisualType} from './constants';
import {visualRuleDefaults} from './defaults';
import {VisualRule} from './types';

type VisualRuleBaseParams<T extends VisualType> = {
	type: T;
} & ([T] extends [VisualType.ASSET]
	? {
			assetId: number;
	  }
	: {
			/** hex color */
			color: string;
	  });

type Asset = VisualRuleBaseParams<VisualType.ASSET>;
type Color = VisualRuleBaseParams<VisualType.COLOR>;

type GetVisualRuleParams = Asset | Color;

export function createVisualRule(params: Asset): VisualRule<VisualType.ASSET>;

export function createVisualRule(params: Color): VisualRule<VisualType.COLOR>;

export function createVisualRule(params: GetVisualRuleParams) {
	const {type} = params;

	return {
		...visualRuleDefaults,
		elementSubType1: type,
		elementValue1: type === VisualType.ASSET ? params.assetId : params.color,
	};
}

export default createVisualRule;
